export const TIPO_TRANSACCION = {
  GASTOS: 1,
  INGRESOS: 2,
} as const

export type TipoTransaccionType =
  (typeof TIPO_TRANSACCION)[keyof typeof TIPO_TRANSACCION]
